import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=e4a8dfe4&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a8dfe4')) {
      api.createRecord('e4a8dfe4', component.options)
    } else {
      api.reload('e4a8dfe4', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=e4a8dfe4&", function () {
      api.rerender('e4a8dfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yQIi04pO0KJp/JS/cancellationPolicy.vue"
export default component.exports